// /home/devuser/Development/avanti-plus/Trogdor/app/react-app/src/apps/public/jobs/pages/jobs/components/EmptyJobList.tsx
import { useTranslation } from "react-i18next";
import { createStyles } from "antd-style";

import { Button } from "@av/components/atoms/Button";
import { Card } from "@av/components/atoms/Card";
import { Image } from "@av/components/atoms/Image";
import { Typography } from "@av/components/atoms/typography/Typography";

const { Title, Paragraph } = Typography;

const useStyles = createStyles(({ token, css }) => ({
  emptyState: css`
    text-align: center;
    padding: ${token.paddingXL}px;
    color: ${token.colorTextSecondary};
  `,
  image: css`
    max-width: 250px;
    width: 100%;
    margin-bottom: ${token.marginLG}px;
  `,
}));

type EmptyJobsStateProps = {
  onClearFiltersApplied?: () => void;
};

export function EmptyJobsState({ onClearFiltersApplied }: EmptyJobsStateProps) {
  const { styles } = useStyles();
  const { t } = useTranslation();

  return (
    <Card
      testIdPrefix="job-details-empty"
      styles={{ body: { padding: 0 } }}
      style={{ width: "100%" }}
    >
      <div className={styles.emptyState}>
        <Image
          testIdPrefix="job-details-empty"
          src="/errors/404_not_found.png"
          preview={false}
          alt={t("recruitment.jobs.empty_imageAlt")}
          className={styles.image}
        />
        {onClearFiltersApplied ? (
          <>
            <Title testIdPrefix="filter-job-details-empty" level={3}>
              {t("recruitment.jobs.empty_filtersAppliedTitle")}
            </Title>
            <Paragraph testIdPrefix="filter-job-detail-empty-message" type="secondary">
              {t("recruitment.jobs.empty_filtersAppliedMessage")}
            </Paragraph>
            <Button type="primary" testIdPrefix="clear-filters" onClick={onClearFiltersApplied}>
              {t("recruitment.jobs.empty_clearFilters")}
            </Button>
          </>
        ) : (
          <>
            <Title testIdPrefix="job-details-empty" level={3}>
              {t("recruitment.jobs.empty_noJobPostsTitle")}
            </Title>

            <Paragraph testIdPrefix="job-details-empty-message" type="secondary">
              {t("recruitment.jobs.empty_noJobPostsMessage")}
            </Paragraph>
          </>
        )}
      </div>
    </Card>
  );
}
